import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Award, Check } from 'lucide-react';
import { Button } from '../components/ui/button';

const RULES = [
  'Treat fellow golfers with respect',
  'Play honestly and report scores accurately',
  'Resolve competition disputes fairly',
  'Avoid harassment or abusive behavior',
  'Represent the Bundle Golf Club community positively',
];

export default function CodeOfConduct() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bundle-cream pb-mobile-nav">
      <div className="bg-bundle-green">
        <div className="max-w-3xl mx-auto px-4 py-8 md:py-12">
          <button
            data-testid="back-btn"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-bundle-cream/70 hover:text-white transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" /> Back
          </button>
          <div className="flex items-center gap-3 mb-3">
            <Award className="w-8 h-8 text-bundle-gold" />
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-white" data-testid="conduct-title">
              Member Code of Conduct
            </h1>
          </div>
          <p className="font-body text-bundle-cream/70 text-sm">Bundle Golf Club Member Rules</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8" data-testid="conduct-content">
        <p className="font-body text-gray-600 leading-relaxed mb-8 text-lg">
          Members agree to uphold the spirit of golf and sportsmanship while participating in the community.
        </p>

        <h2 className="font-heading font-bold text-lg text-bundle-green mb-4 pb-2 border-b border-bundle-cream-dark">
          Members are expected to:
        </h2>

        <div className="space-y-4 mb-8">
          {RULES.map((rule, i) => (
            <div
              key={i}
              data-testid={`rule-${i}`}
              className="flex items-start gap-4 p-4 bg-white/60 rounded-xl"
            >
              <div className="w-8 h-8 rounded-full bg-bundle-green flex items-center justify-center flex-shrink-0">
                <Check className="w-4 h-4 text-white" />
              </div>
              <p className="font-body text-gray-700 text-base leading-relaxed pt-1">{rule}</p>
            </div>
          ))}
        </div>

        <div className="p-4 bg-red-50 border border-red-100 rounded-xl mb-8">
          <p className="font-body text-red-700 font-medium text-sm">
            Violations may result in suspension or removal from the platform.
          </p>
        </div>

        <div className="pt-6 border-t border-bundle-cream-dark text-center">
          <Button data-testid="back-to-home-btn" onClick={() => navigate('/')} className="btn-bundle">
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
